import { Box, Typography } from "@mui/material";
import {
  ArrowMultiIcon,
  Check2Icon,
  DeleteIcon,
  ExclamationIcon,
  HourGlass2Icon,
  NoMenuIcon,
  Pause2Icon,
  RestaurantIcon,
} from "../../assets/icons";

export function PortionLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        background: "rgba(19, 111, 215, 0.08)",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "56px",
        margin: "auto",
      }}
    >
      <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.infoDefault" }}>
        <RestaurantIcon width={24} height={24} />
      </Typography>
    </Box>
  );
}

export function SendLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        background: "rgba(19, 111, 215, 0.08)",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "56px",
        margin: "auto",
      }}
    >
      <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.infoDefault" }}>
        <ExclamationIcon width={24} height={24} />
      </Typography>
    </Box>
  );
}

export function DeleteLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        backgroundColor: "text.errorLighter",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "56px",
        margin: "auto",
      }}
    >
      <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.errorDefault" }}>
        <DeleteIcon width={24} height={24} />
      </Typography>
    </Box>
  );
}

export function PausedLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        backgroundColor: "text.infoLighter",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "72px",
        margin: "auto",
      }}
    >
      <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.infoDefault" }}>
        <Pause2Icon width={32} height={32} />
      </Typography>
    </Box>
  );
}

export function PausedWarningLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        backgroundColor: "text.warningLighter",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "64px",
        height: "64px",
        margin: "auto",
      }}
    >
      <Typography
        sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.warningDark" }}
      >
        <Pause2Icon width={32} height={32} />
      </Typography>
    </Box>
  );
}

export function SkipLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        backgroundColor: "text.secondaryLight",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "72px",
        margin: "auto",
      }}
    >
      <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.secondaryDark" }}>
        <ArrowMultiIcon width={32} height={32} />
      </Typography>
    </Box>
  );
}

export function NoMenuLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        backgroundColor: "text.infoLighter",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "72px",
        margin: "auto",
      }}
    >
      <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.infoDefault" }}>
        <NoMenuIcon width={32} height={32} />
      </Typography>
    </Box>
  );
}

export function SuccessLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        backgroundColor: "text.successLighter",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "72px",
        margin: "auto",
      }}
    >
      <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.successDark" }}>
        <Check2Icon width={32} height={32} />
      </Typography>
    </Box>
  );
}

export function HourglassLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        backgroundColor: "text.successLighter",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "72px",
        margin: "auto",
      }}
    >
      <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.successDark" }}>
        <HourGlass2Icon width={32} height={32} />
      </Typography>
    </Box>
  );
}

export function WarningLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        backgroundColor: "text.warningLighter",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "72px",
        margin: "auto",
      }}
    >
      <Typography sx={{ display: "flex", justifyContent: "center", alignItems: "center", color: "text.warningDark" }}>
        <ExclamationIcon width={32} height={32} />
      </Typography>
    </Box>
  );
}

export function CongratsLabelIcon() {
  return (
    <Box
      sx={{
        borderRadius: "90px",
        backgroundColor: "text.successLighter",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "80px",
        height: "80px",
        margin: "auto",
      }}
    >
      <Typography
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "text.infoDefault",
          fontSize: "24px",
        }}
      >
        🎉
      </Typography>
    </Box>
  );
}
